import { HealthcareProviderCreateMZ15ReportStatisticsCommand } from '@dreryk/egabinet-statistics-frontend-api';
import { ServiceLocationId, ServiceLocationType } from '@dreryk/egabinet-healthcare-provider-published-language-api';
import { HealthcareProviderLocationType } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { assertUnreachable } from '@dreryk/react-common';

import { statisticsTranslationKeys } from '../../../translations';
import { GenerateMZ15FormBean, GenerateMZ15FormController } from '../GenerateMZ15Form.types';

const mapHealthcareProviderLocationTypeToServiceLocationType = (
   healthcareProviderLocationType: HealthcareProviderLocationType
): ServiceLocationType => {
   switch (healthcareProviderLocationType) {
      case 'SERVICE_PROVIDING_LOCATION':
         return ServiceLocationType.SERVICE_PROVIDING_LOCATION;

      case 'HEALTHCARE_FACILITY_LOCATION':
         return ServiceLocationType.HEALTHCARE_FACILITY_LOCATION;

      case 'HEALTHCARE_FACILITY_UNIT':
         return ServiceLocationType.HEALTHCARE_FACILITY_UNIT;

      default:
         return assertUnreachable(healthcareProviderLocationType);
   }
};

export type GenerateStatisticsModalConfirmButtonProps = Pick<GenerateMZ15FormController, 'handleSubmit'> & {
   readonly onSuccess: VoidFunction;
};

export const GenerateMZ15StatisticsButton = (props: GenerateStatisticsModalConfirmButtonProps): JSX.Element => {
   const { executeAsync: createStatistics } = useCqrsCommand<void, GenerateMZ15FormBean>(
      (parameters) => {
         const command = new HealthcareProviderCreateMZ15ReportStatisticsCommand();
         command.locationId = ServiceLocationId.of(
            mapHealthcareProviderLocationTypeToServiceLocationType(
               parameters.healthcareProviderLocation!.locationIdentifier.type
            ),
            parameters.healthcareProviderLocation!.locationIdentifier.locationId
         );
         command.includeVisitsFinishedNotApproved = parameters.includeVisitsFinishedNotApproved;
         command.includeVisitsInProgress = parameters.includeVisitsInProgress;
         command.year = parameters.year;
         return command;
      },
      {
         onSuccess: () => {
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={statisticsTranslationKeys.modal.submit}
         onClick={props.handleSubmit(createStatistics)}
      />
   );
};
